import { memo } from "react";

const ActionFile = () => (
  <svg viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.64537 3.81309C7.5349 2.92356 8.74136 2.42383 9.99935 2.42383H21.666C22.0399 2.42383 22.3986 2.57237 22.663 2.83678L34.3296 14.5034C34.594 14.7679 34.7426 15.1265 34.7426 15.5004V33.8337C34.7426 35.0917 34.2429 36.2982 33.3533 37.1877C32.4638 38.0773 31.2573 38.577 29.9993 38.577H9.99935C8.74136 38.577 7.5349 38.0773 6.64537 37.1877C5.75584 36.2982 5.2561 35.0917 5.2561 33.8337V7.16707C5.2561 5.90909 5.75584 4.70262 6.64537 3.81309ZM9.99935 5.24365C9.48923 5.24365 9 5.4463 8.63929 5.80701C8.27857 6.16772 8.07593 6.65695 8.07593 7.16707V33.8337C8.07593 34.3439 8.27857 34.8331 8.63929 35.1938C9 35.5545 9.48923 35.7572 9.99935 35.7572H29.9993C30.5095 35.7572 30.9987 35.5545 31.3594 35.1938C31.7201 34.8331 31.9228 34.3439 31.9228 33.8337V16.0844L21.082 5.24365H9.99935Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.666 2.42383C22.4447 2.42383 23.0759 3.05507 23.0759 3.83374V14.0905H33.3327C34.1114 14.0905 34.7426 14.7217 34.7426 15.5004C34.7426 16.2791 34.1114 16.9103 33.3327 16.9103H21.666C20.8873 16.9103 20.2561 16.2791 20.2561 15.5004V3.83374C20.2561 3.05507 20.8873 2.42383 21.666 2.42383Z"
      fill="currentColor"
    />
  </svg>
);

export default memo(ActionFile);
